import React, { useState } from 'react';
import SvgIcon from '../../../../../common/SvgIcon';

const Links = ({ project, disabled, updateProject }) => {
  const [links, setLinks] = useState([
    { link: project.questionnaire.pinterest_link, type: 'pinterest_link', placeholder: 'Pinterest Board Link', removable: false },
    { link: project.questionnaire.houzz_link, type: 'houzz_link', placeholder: 'Houzz Idea Board Link', removable: false },
    ...project.questionnaire.additional_links.map((l, index) => ({ link: l, type: `al_${index}`, placeholder: 'Link', removable: true })),
  ]);

  const handleSave = (links) => {
    const projectLinks = links.reduce((acct, l) => {
      if (['pinterest_link', 'houzz_link'].includes(l.type)) {
        return {
          ...acct,
          [l.type]: l.link,
        };
      } else {
        return !l.link
          ? acct
          : {
            ...acct,
            additional_links: {
              ...(acct.additional_links || {}),
              [l.type]: l.link,
            },
          };
      }
    }, {});
    const { additional_links = {}, ...rest } = projectLinks;
    updateProject({
      questionnaire_attributes: {
        ...rest,
        additional_links: Object.values(additional_links),
      },
    });
  };

  const handleAdd = (event) => {
    const newLink = { link: '', type: `link_${links.length}`, placeholder: 'Link', removable: true };
    event.preventDefault();
    setLinks([...links, newLink]);
  };

  const handleRemove = (link) => {
    const newLinks = links.filter(l => l.type !== link.type);
    setLinks(newLinks);
    handleSave(newLinks);
  };

  const handleChange = (event) => {
    const newLinks = links.map(l => {
      if (l.type !== event.target.name) return l;
      return { ...l, link: event.target.value };
    });
    setLinks(newLinks);
    handleSave(newLinks);
  };

  return (
    <div className="onboarding-fields onboarding-links -uploading">
      <div className="clearfix">
        {links.map((link, index) => (
          <div className="onboarding-fields_col -w50" key={`link_${index}`}>
            <input
              className="form-control -border-black"
              name={link.type}
              onChange={handleChange}
              value={link.link}
              placeholder={link.placeholder}
              disabled={disabled}
            />
            {link.removable && (
              <div className="onboarding-fields_remove" onClick={() => handleRemove(link)}>
                <SvgIcon icon="icon-remove-button" />
              </div>
            )}
          </div>
        ))}
      </div>
      {!disabled && (
        <div className="clearfix">
          <div className="onboarding-fields_col -w100">
            <a href="#" onClick={handleAdd}>+ another link</a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Links;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Links.js